import Link from 'next/link';
import { useState } from 'react';
import { VermButton } from '../../HomePage/Articles/styled';
import {
  CardCount,
  CardName,
  ListImage,
  MoreTopicButton,
  TagListBox,
  TagListWrapper,
} from './styled';

export default function TagListSection(props) {
  const { listData } = props;
  const [limitCount, setLimitCount] = useState(9);
  return (
    <>
      <TagListWrapper>
        {listData?.map((item, index) => {
          if (index < limitCount) {
            return (
              <Link
                href={`/topic/${item?.term_id}`}
                key={`alltags${index}`}
                locale={false}
              >
                <TagListBox
                  onClick={() =>
                    localStorage.setItem('category_img', item?.image)
                  }
                >
                  <ListImage src={item?.image} alt="" />
                  {item?.contentCount > 0 && (
                    <CardCount>
                      {item?.contentCount.toLocaleString('en-IN')} Posts
                    </CardCount>
                  )}
                  <CardName>
                    <h2>{item?.description}</h2>
                  </CardName>
                </TagListBox>
              </Link>
            );
          }
        })}
      </TagListWrapper>
      {limitCount < listData?.length && (
        <MoreTopicButton onClick={() => setLimitCount(limitCount + 9)}>
          <VermButton lg>Load More Topics</VermButton>
        </MoreTopicButton>
      )}
    </>
  );
}
